export default __webpack_public_path__ + "static/Gareth-Dummer-9044e6d0f1b48045d12cc5eb33fbec84.png";